module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteFooterItem(_vm.item.id)
      }
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Ссылка"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.item.url),
      callback: function($$v) {
        _vm.$set(_vm.item, "url", $$v)
      },
      expression: "item.url"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59dad288"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/FooterItem.vue
// module id = 951
// module chunks = 0